import { render, staticRenderFns } from "./MotivoRetorno.vue?vue&type=template&id=73d2be2f&"
import script from "./MotivoRetorno.vue?vue&type=script&lang=js&"
export * from "./MotivoRetorno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports